var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AdornerModel } from "./adorner";
import { bindable } from "aurelia-templating";
import { AdornerService } from "../../../services/basics/adorner-service";
import { autoinject, transient } from "aurelia-dependency-injection";
var Adorned = /** @class */ (function () {
    function Adorned(adornerService, element) {
        this.adornerService = adornerService;
        this.element = element;
    }
    Adorned.prototype.attached = function () {
        this.attachElement();
    };
    Adorned.prototype.contextChanged = function (newValue, oldValue) {
        this.attachElement();
    };
    Adorned.prototype.viewChanged = function (newValue, oldValue) {
        this.html = this.view ? this.view.replace(/<template>/g, "").replace(/<\/template>/g, "") : "";
        this.attachElement();
    };
    Adorned.prototype.elementChanged = function (newValue, oldValue) {
        this.attachElement();
    };
    Adorned.prototype.attachElement = function () {
        if (this.context && this.html && this.element) {
            if (this.adorner) {
                this.adornerService.remove(this.adorner);
            }
            this.adorner = new AdornerModel(this.context, this.html, this.element);
            this.adornerService.add(this.adorner);
        }
    };
    Adorned.prototype.detached = function () {
        this.adornerService.remove(this.adorner);
    };
    __decorate([
        bindable(),
        __metadata("design:type", Object)
    ], Adorned.prototype, "context", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", String)
    ], Adorned.prototype, "view", void 0);
    Adorned = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [AdornerService, Element])
    ], Adorned);
    return Adorned;
}());
export { Adorned };
